import Icon from '../components/Icon.vue';
Icon.register({
  faucet: {
    width: 512,
    height: 512,
    paths: [{
      d: 'M352 256c88.3 0 160 71.7 160 160 0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32s-14.3-32-32-32h-12.8c-20.6 37.7-64.2 64-115.2 64s-94.6-26.3-115.2-64h-92.8c-8.8 0-16-7.2-16-16v-96c0-8.8 7.2-16 16-16h118.6c15.7-13.4 35.5-23 57.4-28v-47.6l32-3.4 32 3.4v47.6c21.9 4.9 41.7 14.6 57.4 28h38.6zM81.6 159.9c-9.4 1-17.6-6.8-17.6-16.8v-30.2c0-10 8.2-17.8 17.6-16.8l110.4 11.7v-27.7c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v27.7l110.4-11.7c9.4-1 17.6 6.8 17.6 16.8v30.2c0 10-8.2 17.8-17.6 16.8l-142.4-15z'
    }]
  }
});